import React, { useRef, useEffect } from 'react'
import styled from 'styled-components'

const StyledTextArea = styled.textarea`
  overflow: hidden;
  resize: none;
`

const TextArea = ({ value, ...props }) => {
  const ref = useRef(null)
  useEffect(() => {
    ref.current.style.height = 0
    ref.current.style.height = Math.max(150, ref.current.scrollHeight) + 'px'
  }, [value])

  return <StyledTextArea ref={ref} value={value} {...props} />
}

export default TextArea
